import { Component, EventEmitter, HostBinding, Input, OnChanges, Output } from '@angular/core';
import { AssociationByCandidateIdJobIdObj } from '@collections/associations';
import { getAssociationRejectedConfigurations } from '@modules/assigns/store';
import { Store } from '@ngrx/store';
import { DropdownMenuWithIconsService } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.service';
import { AssociationStatusConfigurationTypes } from '@shared/models';
import { of } from 'rxjs';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { DropdownMenuItem } from 'mojo-abstract-dropdown-menu';

@Component({
  selector: 'mojo-dropdown-menu-with-reject',
  template: `<mojo-dropdown-menu-with-icons
    (dropdownOver)="setOver($event)"
    [targetId]="candidateId"
    [menuItems]="menuItems$ | async">
  </mojo-dropdown-menu-with-icons>`,
  styleUrls: ['./dropdown-menu-with-reject.component.scss'],
})
export class DropdownMenuWithRejectComponent implements OnChanges {
  @Input() candidateId: number;
  @Input() jobId: number;
  @Input() upperMenu: DropdownMenuItem[];
  @Input() lowerMenu: DropdownMenuItem[];
  @HostBinding('class.hover-block') hover = false;
  @Output() dropdownOver = new EventEmitter<boolean>();
  menuItems$;

  constructor(
    private store: Store,
    private dropdownMenuWithIconsService: DropdownMenuWithIconsService,
  ) {}

  ngOnChanges() {
    this.menuItems$ = of(...this.upperMenu, ...this.lowerMenu);
    this.menuItems$ = this.store
      .select(
        AssociationByCandidateIdJobIdObj.getAssociationByCandidateIdAndJobId(
          this.candidateId,
          this.jobId,
        ),
      )
      .pipe(
        switchMap((association) =>
          this.store.select(getAssociationRejectedConfigurations, {
            jobId: association?.reqId,
            configurationStateId: association?.status,
          }),
        ),
        withLatestFrom(
          this.dropdownMenuWithIconsService.isInRejected(this.candidateId, this.jobId),
        ),
        switchMap(([config, rejected]) => {
          const rejectItems: DropdownMenuItem[] = [];
          if (!rejected) {
            for (const configKey of config) {
              const index = config.indexOf(configKey);
              rejectItems.push({
                icon: this.getIconForType(configKey.type),
                text: configKey.label,
                callback: (candidateId) =>
                  this.dropdownMenuWithIconsService.openRejectModal(
                    this.jobId,
                    candidateId,
                    configKey.id,
                  ),
                topLine: index === 0,
                bottomLine: index === config.length - 1,
              });
            }
          }
          return of([...this.upperMenu, ...rejectItems, ...this.lowerMenu]);
        }),
      );
  }

  setOver(e) {
    this.dropdownOver.emit(e);
    this.hover = e;
  }

  private getIconForType(type: AssociationStatusConfigurationTypes): string {
    switch (type) {
      case AssociationStatusConfigurationTypes.WITHDRAWN:
        return 'person_off';
      case AssociationStatusConfigurationTypes.DECLINED:
        return 'person_off';
      case AssociationStatusConfigurationTypes.REJECTED:
        return 'cancel';
    }
  }
}
